import MolhamButton from "components/ReuseableCompos/MolhamButton";
import { useModeContext } from "context/ModeContext";
import useMobile from "customHooks/useMobile";
import useModal from "customHooks/useModal";
import { nextCheckoutItemSourceManager } from "customHooks/useNextCheckoutItemSource";
import useRTL from "customHooks/useRTL";
import useUtilities from "customHooks/useUtilities";
import useWindowSize from "customHooks/useWindowSize";
import useTranslation from "next-translate/useTranslation";
import Image from "next/image";
import { Modal } from "react-bootstrap";
import CountUp from "react-countup";
import styled from "styled-components";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { A11y, Autoplay, EffectFade, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
type Props = {
  promoVid?: string;
  sliderBtns?: any;
};

const desktopSlides = [
  // "https://cdn.molhamteam.com/assets/homepage-sliders/hero-1.webp",
  "https://cdn.molhamteam.com/assets/homepage-sliders/hero-2.webp",
  "https://cdn.molhamteam.com/assets/homepage-sliders/hero-3.webp",
  "https://cdn.molhamteam.com/assets/homepage-sliders/hero-4.webp",
  "https://cdn.molhamteam.com/assets/homepage-sliders/hero-5.webp",
];
const mobileSlides = [
  // "https://cdn.molhamteam.com/assets/homepage-sliders/hero-1-mob.webp",
  "https://cdn.molhamteam.com/assets/homepage-sliders/hero-2-mob.webp",
  "https://cdn.molhamteam.com/assets/homepage-sliders/hero-3-mob.webp",
  "https://cdn.molhamteam.com/assets/homepage-sliders/hero-4-mob.webp",
  "https://cdn.molhamteam.com/assets/homepage-sliders/hero-5-mob.webp",
];

function HomeIntroSlider({ promoVid }: Props) {
  const { theme } = useModeContext();
  const isRTL = useRTL();
  const logo =
    "https://cdn.molhamteam.com/assets/img/logo/logo-small-screen.png";
  const { height, width } = useWindowSize();

  const isMobile = useMobile("md");
  const { t } = useTranslation("common");
  const { data: utilities } = useUtilities();
  const targetsStats = utilities?.targets_stats;
  const counterData = [
    { title: "cases", value: targetsStats?.cases ?? 0 },
    { title: "campaigns", value: targetsStats?.campaigns ?? 0 },
    { title: "sponsorships", value: targetsStats?.sponsorships ?? 0 },
    { title: "students", value: targetsStats?.students ?? 0 },
  ];
  const sliderBtns = [
    // {
    //   label: "ramadan_campaigns",
    //   href: "/ramadan",
    //   startIcon: "fe-arrow-left",
    //   endIcon: null,
    //   color: "success",
    // },
    {
      label: "quick_donation",
      href: "#quick_donate",
      startIcon: "fe-heart",
      endIcon: null,
      color: "danger",
    },
    {
      label: "donation_sections",
      href: "/donate",
      startIcon: null,
      endIcon: "fe-arrow-right",
      color: "primary2",
    },
  ];

  const { handleCloseModal, handleShowModal, showModal } = useModal();
  const onPlayClick = () => {
    if (!promoVid) return;
    handleShowModal();
  };
  return (
    <StyledHomeIntroSlider
      isRTL={isRTL}
      className="position-relative user-select-none"
    >
      <Modal
        onHide={handleCloseModal}
        show={showModal}
        centered
        contentClassName="video-modal-content"
        backdropClassName="video-modal-backdrop"
        size="xl"
      >
        <Modal.Body className="video-modal-body">
          <StyledIframeContainer>
            <iframe
              src={promoVid}
              title="Promotional Video"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
          </StyledIframeContainer>
        </Modal.Body>
      </Modal>
      <div
        className="position-absolute top-50 start-50 translate-middle zindex-2 w-100"
        style={isMobile ? { height: "75%" } : { height: "85%" }}
      >
        <div className="v-centered justify-content-around flex-column w-100 h-100 ">
          <div className="centered flex-column">
            <div
              className={`p-3 mb-3 mb-md-4 rounded-circle text-shadow ${
                promoVid ? "cursor" : ""
              }`}
              onClick={onPlayClick}
              style={{
                // boxShadow: `0 0 1rem 20rem #000`,
                backgroundColor: "#fff",
              }}
            >
              {promoVid ? (
                <i
                  className="fe-play text-primary fs-xxl centered ml-1"
                  style={{ width: "20px", height: "24px" }}
                ></i>
              ) : (
                <Image
                  alt="logo"
                  unoptimized
                  src={logo}
                  width={isMobile ? 50 : 60}
                  height={isMobile ? 50 : 60}
                />
              )}
            </div>
            <h1 className=" mb-3 mb-md-4 w-100 text-center text-white-always text-shadow">
              {t("molham_volunteering_team")}
            </h1>
            <h2 className=" text-center text-white-always text-shadow">
              {t("inspire_humanity")}
            </h2>
          </div>
          {!isMobile && <CounterFormatter counterData={counterData} t={t} />}
          <div className="centered flex-column flex-md-row w-100 gap-4">
            {sliderBtns.map((b, i) => {
              return (
                <StyledSliderBtn
                  color={"var(--" + b.color + ")"}
                  onClick={() => {
                    if (b.href === "/donate") {
                      nextCheckoutItemSourceManager.setNextCheckoutItemSource(
                        nextCheckoutItemSourceManager.options.promo_widget,
                      );
                    }
                  }}
                  key={i}
                  id={"slider-" + b.label + "-btn"}
                  labelClassName="fw-bold"
                  startIcon={b.startIcon}
                  endIcon={b.endIcon}
                  variant="light"
                  label={t(b.label)}
                  href={b.href}
                />
              );
            })}
          </div>
        </div>
      </div>
      <StyledSwiper
        modules={[Navigation, A11y, Autoplay, EffectFade]}
        loop
        slidesPerView={1}
        dir={isRTL ? "rtl" : "ltr"}
        theme={theme}
        key={isRTL.toString()}
        effect="fade"
        autoplay={{
          delay: 7500,
        }}
      >
        {(isMobile ? mobileSlides : desktopSlides).map((item, index) => {
          return (
            <SwiperSlide key={index} className="">
              <Image
                className={"image"}
                unoptimized
                src={item}
                alt={"intro"}
                width={width || 1920}
                height={height || 1080}
                style={{
                  height: "85vh",
                  maxHeight: "85vh",
                  objectFit: "cover",
                  transition: "filter 0.3s",
                  width: "100%",
                  filter:
                    theme === "dark" ? "brightness(0.65)" : "brightness(0.9)",
                }}
              />
            </SwiperSlide>
          );
        })}
      </StyledSwiper>
    </StyledHomeIntroSlider>
  );
}

export default HomeIntroSlider;

const CounterFormatter = ({ counterData, t }) => {
  return (
    <div className="centered">
      {counterData.map((item, index) => {
        const isLast = index === counterData.length - 1;
        return (
          <div
            key={index}
            className={`centered text-center flex-column
          ${!isLast && "pe-3 me-3 seperator"}
          
          `}
            style={{ minWidth: "150px" }}
          >
            <CountUp
              className="text-white-always h2 fw-bold"
              end={item.value}
            />

            <h4 className="text-white-always fw-bold mb-0">{t(item.title)}</h4>
          </div>
        );
      })}
    </div>
  );
};

const StyledSwiper = styled(Swiper)`
  .swiper-pagination {
    width: 100%;
    text-align: center !important;
    bottom: 0 !important;
    @media (max-width: 768px) {
      bottom: 12px !important;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    /* top: 148px !important; */
    background: #fff !important;
    border-radius: 25% !important;
    width: 50px !important;
    height: 50px !important;
    @media (max-width: 767.98px) {
      display: none !important;
    }
  }
  .swiper-button-prev::after {
    margin-inline-end: 4px !important;
    z-index: 3 !important;
  }

  .swiper-button-next {
    margin-inline-start: 4px !important;
    z-index: 3 !important;
  }

  .swiper-button-prev::after,
  .swiper-button-next::after {
    color: var(--primary2) !important;

    font-size: 25px !important;
  }

  .swiper-button-disabled {
    display: none !important;
  }
`;
const StyledSliderBtn = styled(MolhamButton)<{
  color: string;
  key: string | number;
}>`
  color: ${(props) => props.color} !important;
  background-color: #fff;
  &:hover {
    color: #fff !important;
    background-color: ${(props) => props.color} !important;
    border: 1px solid ${(props) => props.color} !important;
  }
  min-width: 250px;

  height: unset !important;
  max-height: unset !important;
  font-size: 18px;
  &:focus {
    background-color: #fff;
    border: 1px solid #fff;
  }
`;
const StyledDSB = styled(MolhamButton)`
  color: var(--primary2) !important;
  background-color: #fff;

  &:hover {
    color: #fff !important;
    background-color: var(--primary2) !important;
    border: 1px solid var(--primary2) !important;
  }
  min-width: 250px;

  height: unset !important;
  max-height: unset !important;
  font-size: 18px;
`;
const StyledIframeContainer = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
  border-radius: 10px;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    inset 0 0 20px rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: containerPulse 2s ease-in-out infinite;

  @keyframes containerPulse {
    0%,
    100% {
      box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.3),
        inset 0 0 20px rgba(255, 255, 255, 0.05);
    }
    50% {
      box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.4),
        inset 0 0 25px rgba(255, 255, 255, 0.1);
    }
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 10px;
    background: #000;
  }

  @media (max-width: 768px) {
    padding-bottom: 56.25%;
    border-radius: 8px;
  }
`;

const StyledHomeIntroSlider = styled.div<{
  isRTL: boolean;
}>`
  .seperator {
    border-right: ${({ isRTL }) => (!isRTL ? "1px solid #f7f7fc" : "unset")};
    border-left: ${({ isRTL }) => (isRTL ? "1px solid #f7f7fc" : "unset")};
  }

  .modal {
    animation: modalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  @keyframes modalSlideIn {
    from {
      opacity: 0;
      transform: translateY(-50px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  .video-modal-content {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    border: 2px solid rgba(0, 0, 0, 0.05);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
    overflow: hidden;
  }

  .video-modal-backdrop {
    background: rgba(0, 0, 0, 0.65);
    backdrop-filter: blur(6px);
    animation: backdropFadeIn 0.3s ease-in;
  }

  @keyframes backdropFadeIn {
    from {
      opacity: 0;
      backdrop-filter: blur(0px);
    }
    to {
      opacity: 1;
      backdrop-filter: blur(6px);
    }
  }

  .video-modal-header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    padding: 1.75rem 1.75rem 1.5rem;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0.3) 100%
    );
    display: flex;
    justify-content: space-between;
    align-items: center;

    .video-modal-title {
      font-weight: 700;
      color: var(--primary2);
      font-size: 1.4rem;
      letter-spacing: -0.5px;
      margin: 0;
    }

    .btn-close {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(0, 0, 0, 0.1);
      transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
      filter: brightness(0.6);

      &:hover {
        background: rgba(220, 53, 69, 0.1);
        border-color: rgba(220, 53, 69, 0.3);
        filter: brightness(1);
        transform: scale(1.1) rotate(90deg);
      }

      &:focus {
        outline: 2px solid var(--primary2);
        outline-offset: 2px;
      }
    }
  }

  .video-modal-body {
    padding: 2rem;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.7) 0%,
      rgba(248, 249, 250, 0.7) 100%
    );

    @media (max-width: 768px) {
      padding: 1.5rem;
    }

    @media (max-width: 576px) {
      padding: 1rem;
    }
  }

  .modal-header {
    border-bottom: none;
  }

  .modal-dialog {
    animation: dialogSlideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  @keyframes dialogSlideUp {
    from {
      transform: translateY(30px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    .modal-lg {
      max-width: 95vw !important;
      margin: auto !important;
    }

    .video-modal-header {
      padding: 1.25rem;
    }

    .video-modal-title {
      font-size: 1.1rem;
    }

    .btn-close {
      width: 32px;
      height: 32px;
    }
  }

  @media (max-width: 576px) {
    .video-modal-content {
      border-radius: 12px;
    }

    .video-modal-header {
      padding: 1rem;
    }

    .video-modal-title {
      font-size: 1rem;
    }
  }
`;
